import { EMPTY_ARRAY } from '@applyonline/shared';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import apiClient from './api-client';
const SCOPE_CANCEL = 'cancel-reasons';
const SCOPE_BAD_REVIEW = 'bad-review-reasons';
const SCOPE_PROVINCE_CONFIGS = 'province-configs';
const keysFactory = {
    cancelReasons: (financingProgram) => [{ scope: SCOPE_CANCEL, financingProgram }],
    badReviewReasons: (financingProgram) => [{ scope: SCOPE_BAD_REVIEW, financingProgram }],
    provinceConfigs: (financingProgram) => [{ scope: SCOPE_PROVINCE_CONFIGS, financingProgram }],
};
function buildValueList(list, lang) {
    if (!list)
        return EMPTY_ARRAY;
    const inputList = [...list.items];
    if (list.sortMethod === 'priority')
        inputList.sort((x) => x.priority ?? 0);
    const items = inputList.map((x) => {
        return {
            id: x.value,
            text: lang === 'fr' ? x.textFr : x.textEn,
            contactClient: x.contactClient,
        };
    });
    if (list.sortMethod === 'alpha')
        items.sort((one, two) => (one.text > two.text ? -1 : 1));
    return items;
}
const createGetCancelReasons = (financingProgram) => {
    return async () => {
        const response = await apiClient.get(`${financingProgram}/GetWithdrawalReasons`);
        return response.data;
    };
};
const createGetBadReviewReasons = (financingProgram) => {
    return async () => {
        const response = await apiClient.get(`${financingProgram}/GetBadReviewReasons`);
        return response.data;
    };
};
const createGetAllProvincesConfigs = (financingProgram) => {
    return async () => {
        const response = await apiClient.get(`${financingProgram}/Configs/GetAllProvincesConfigs`);
        return response.data;
    };
};
export function useCancelReasons(financingProgram, lang) {
    const getCancelReasons = createGetCancelReasons(financingProgram);
    const { isFetching, data } = useQuery({
        queryKey: keysFactory.cancelReasons(financingProgram),
        queryFn: getCancelReasons,
    });
    const list = useMemo(() => {
        return buildValueList(data, lang);
    }, [data, lang]);
    return [list, isFetching];
}
export function useBadReviewReasons(financingProgram, lang) {
    const getBadReviewReasons = createGetBadReviewReasons(financingProgram);
    const { isFetching, data } = useQuery({
        queryKey: keysFactory.badReviewReasons(financingProgram),
        queryFn: getBadReviewReasons,
    });
    const list = useMemo(() => {
        return buildValueList(data, lang);
    }, [data, lang]);
    return [list, isFetching];
}
export function useGetProvincesConfigs(financingProgram) {
    const getAllProvincesConfigs = createGetAllProvincesConfigs(financingProgram);
    const { isFetching, data } = useQuery({
        queryKey: keysFactory.provinceConfigs(financingProgram),
        queryFn: getAllProvincesConfigs,
    });
    return [data ?? {}, isFetching];
}
